import { render, staticRenderFns } from "./SkeletonHeader.vue?vue&type=template&id=6fd0809e&scoped=true"
import script from "./SkeletonHeader.vue?vue&type=script&lang=js"
export * from "./SkeletonHeader.vue?vue&type=script&lang=js"
import style0 from "./SkeletonHeader.vue?vue&type=style&index=0&id=6fd0809e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0809e",
  null
  
)

export default component.exports